module.exports = __webpack_public_path__ + "static/sapiens-43876a1a70803e6714355ffbfdfa874b.webp";